import React from 'react';
import './RangeSlider.css';
import ElasticSlider from './ElasticSlider'

const RangeSlider = (props) => {
    return ( 
        <div className='RangeSlider'>
            <ElasticSlider
                leftIcon={props.LeftValue}
                rightIcon={props.RightValue}
                startingValue={0}
                defaultValue={50}
                maxValue={500}
                isStepped={false}
                stepSize={1}
            />
        </div> 
     );
}
 
export default RangeSlider;